.header {
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 20px;
}

.text {
  font-weight: 800;
}

.actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 20px;
}

.reasons {
  color: var(--palettePrimary0);
  fill: var(--palettePrimary0);
  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    margin-right: 6px;
  }
}

.selectReason {
  width: 200px;
}

.bookedOrFilled {
  margin-top: 12px;
}

.toggleWrapper {
  display: flex;
  flex-direction: row;
  gap: var(--spacingMd);
  align-items: center;
}
